import Router from 'lib/Router';

import IndexView from 'view/default/index';
import LoginView from 'view/default/login';

export default Router.extend({
	routes: {
		'': 'executeIndex',
		'default/index': 'executeIndex',
		'default/login': 'executeLogin',
		'default/logout': 'executeLogout',
		'default/back': 'executeBack',
		'*path': 'executeError404',
	},

	unsecure: [ 'executeIndex', 'executeLogin', 'executeLogout', 'executeError404', 'executeBack' ],

	// Page d'accueil
	executeIndex: function()
	{
		// Création de la vue
		var view = new IndexView({
			model: app.getStore('user'),
		});

		// On l'applique
		app.render( view );

		// Puis on synchronise les données et si données reçues, on rafraichi
// 		app.sync();

		// Nettoyage de l'historique !
		app.history = [ 'default/index' ];
	},


	// Connexion (erreur 403)
	executeLogin: function()
	{
		if( app.is('authenticated') )
		{
			return app.redirect('default/index');
		}

		var view = new LoginView({
			model: app.getStore('user'),
		});

		app.render( view, 'default/index' );
	},


	// Déconnexion
	executeLogout: function()
	{
		if( !app.is('authenticated') )
		{
			return app.redirect('default/index');
		}

		// Déconnexion temporiser pour créer une impression de sécurité
		var timer = $.Deferred();
		timer.done(function()
		{
			app.signout();
			app.redirect('default/index');
		});

		app.addMessage( "Déconnexion de l'application", timer );
		setTimeout( timer.resolve, Math.floor( Math.random() * 1000 ) + 500 );
	},




	// Erreur 404
	executeError404: function( path )
	{
		console.warn( 'Error', 404, path );
		console.error404();
	}
});
